"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.report = exports.measure = exports.reset = exports.setEnabled = void 0;
var _isEnabled = false;
function setEnabled(isEnabled) {
    _isEnabled = isEnabled;
}
exports.setEnabled = setEnabled;
var _measurements = {};
function reset() {
    _measurements = {};
}
exports.reset = reset;
var t0 = 0;
var measure = function (key, action) {
    if (!_isEnabled) {
        return action();
    }
    var t0 = performance.now();
    var ret = action();
    var t1 = performance.now();
    var d = t1 - t0;
    if (d < 0) {
        // Bad measurement, skip
        return ret;
    }
    var m = _measurements[key];
    if (!m) {
        m = {
            key: key,
            min: d,
            max: d,
            mean: d,
            last: d,
            num: 1,
        };
        _measurements[key] = m;
    }
    else {
        m.num++;
        if (d < m.min) {
            m.min = d;
        }
        if (d > m.max) {
            m.max = d;
        }
        m.last = d;
        m.mean = m.mean + (d - m.mean) / m.num;
    }
    return ret;
};
exports.measure = measure;
var report = function () {
    exports.measure('perf-report', function () {
        // Create an array from all measurements
        var keys = Object.keys(_measurements);
        var measurements = keys.map(function (k) { return _measurements[k]; });
        measurements.sort(function (a, b) { return a.mean - b.mean; });
        // Change from numbers to strings
        var decimals = 2;
        var formattedMeasurements = measurements.map(function (m) {
            return __assign(__assign({}, m), { min: m.min.toFixed(decimals), max: m.max.toFixed(decimals), mean: m.mean.toFixed(decimals), last: m.last.toFixed(decimals) });
        });
        console.info('Performance report:', _isEnabled);
        console.table(formattedMeasurements);
        // console.table(measurements)
        // console.log(formattedMeasurements)
    });
};
exports.report = report;
